import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import * as schemaServiceTypes from 'src/services/storage/project/scheme/types'
import * as iconifyServiceTypes from 'src/services/iconify'
import { INotifyProps } from 'src/components/ui/notify/Notify'

export const PREFIX = `app`
export const PREFIX_SAGA = `${PREFIX}/sagas`

export const actions = createPhaseActions(PREFIX_SAGA, {
  tost: phaseAction<INotifyProps>(),
  toastDismiss: phaseAction<{ id: string }>(),
  navigate: phaseAction<{
    path?: string
    search?: Record<string, any>
    key?: string
    replaced?: boolean
  }>(),
  fieldsGroups: phaseAction<{
    schemaName: string
    items: schemaServiceTypes.IFieldsGroupData[]
    previousCursor?: string | null
    nextCursor?: string | null
  }>(),
  getAdminSchemas: phaseAction<schemaServiceTypes.IGetSchemasParams>(),
  getSchemas: phaseAction<schemaServiceTypes.IGetSchemasParams>(),
  getSchemasByType: phaseAction<schemaServiceTypes.IGetSchemasParams>(),
  loadMoreSchemas: phaseAction<schemaServiceTypes.IGetSchemasParams>(),
  loadMoreAdminSchemas: phaseAction<schemaServiceTypes.IGetSchemasParams>(),

  postSchemas: phaseAction<schemaServiceTypes.IPostSchemasParams>(),
  putSchemas: phaseAction<schemaServiceTypes.IPutSchemasParams>(),
  getSingleSchema: phaseAction<schemaServiceTypes.IGetSingleSchema>(),
  deleteSchemas: phaseAction<schemaServiceTypes.IDeleteSchemasParams>(),
  logging: phaseAction<void>(),
  cacheStorage: phaseAction<void>(),
  realtimeConnection: phaseAction<void>(),

  getIconSearch: phaseAction<iconifyServiceTypes.IGetIconSearchPrams>(),
  getIconSearchMore: phaseAction<void>(),
  smartListsCountUp: phaseAction<{ schemeName: string; number: number }>(),
  stageFieldsCountUp: phaseAction<{ schemeName: string; number: number }>(),

  // getIconCollection: phaseAction<iconifyServiceTypes.IGetIconCollectionPrams>(),
})

export type Actions = typeof actions
